<template>
  <section class="py-16 md:px-5">
    <div class="max-w-7xl mx-auto flex flex-col items-center">
      <h2 class="text-2xl md:text-4xl font-semibold text-[#373737] mb-12 text-center">
        {{ $t("integration.title") }}
      </h2>

      <div class="w-full flex justify-center mb-16">
        <LogoMarquee :items="items" />
      </div>

      <div class="w-full flex flex-col items-center">
        <p class="text-2xl font-semibold text-[#373737] mb-4 text-center">
          {{ $t("integration.description") }}
        </p>
        <p class="text-base text-[#373737] mb-8 text-center max-w-3xl">
          {{ $t("integration.note") }}
        </p>
        <button
          class="bg-[#600e0e] text-white font-semibold h-12 text-lg px-10 rounded transition-colors duration-200 hover:bg-[#4a0b0b] mx-auto"
          @click="openCTALink"
        >
          {{ $t("integration.exploreApis") }}
        </button>
      </div>
    </div>
  </section>
</template>

<script setup>
import { onMounted, ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import LogoMarquee from "./LogoMarquee.vue"
import commonService from "@/services/commonService";
import { API_DOCS_URL } from "@/config/constants";  

const { locale } = useI18n();
const items = ref([]);
const autoSlideInterval = ref(5000);
const header = ref("Integrated With Your Favorite Apps");
const subHeader = ref(
  "Seamlessly connect your favorite tools and streamline your workflows with our integrated app ecosystem."
);
const CTALink = ref(API_DOCS_URL);

function openCTALink() {
  if (CTALink.value) {
    let url = CTALink.value;
    console.log("Opening URL:", url);
    if (!/^https?:\/\//i.test(url)) {
      url = "https://" + url;
    }
    window.open(url, "_blank");
  }
}

const fetchIntegratedApps = async () => {
  try {
    const data = await commonService.fetchIntegratedAppsData();
    items.value = data?.items || [];
    header.value = data?.Header || header.value;
    subHeader.value = data?.SubHeader || subHeader.value;
    CTALink.value = data?.linkToRedirect?.Uri || CTALink.value;
    autoSlideInterval.value = data.AutoSlideInterval || 5000;
  } catch (error) {
    console.error("Error fetching carousel:", error);
  }
};

onMounted(fetchIntegratedApps);

// 🟡 Re-fetch when locale changes
watch(locale, () => {
  fetchIntegratedApps();
});
</script>
<style scoped>
.text-white {
  color: #fff;
}
</style>
